import { useEffect } from 'react'
import { graphql } from 'gatsby'
import { Headline } from '@dfds-ui/react-components'
import { FlexBox } from '@dfds-ui/react-components/flexbox/FlexBox'
import styled from '@emotion/styled'
import { media, theme } from '@dfds-ui/theme'

import { FlexCard } from '../Card'
import { gridMap } from '../../utils'
import { Markdown } from '../Markdown'

const FlexContainer = styled(FlexBox)`
  height: 100%;
  padding: 20px;
  flex: 1;
  background: ${theme.colors.surface.secondary};

  ${media.greaterThan('l')`
    border: 20px solid white;

    .cb-section-search .cb-section-inner {
      display: flex;
      align-items: flex-end;
      flex-direction: column;
    }
    .cb-item.cb-item-search {
      width: 50%;
    }
  `}
`
const FormContainer = styled.div`
  height: 100%;
  width: 100%;

  .cb-widget-standard {
    height: 100%;
  }

  .cb-sections {
    height: 100%;
  }

  .cb-sections-inner {
    height: 100%;
    justify-content: space-evenly;
  }
`

const TourOperatorWidget = ({ title, text, widgetSource, widgetLocale }) => {
  const widgetSettings = {
    Danish: {
      path: '/da-dk/passagerfaerger/storbyferie',
      token: 'a707bce1-129c-49ca-9aa9-8fc435dcf157',
      onlineid: '84195279',
      cbis: widgetSource,
    },
    Dutch: {
      path: '/nl-nl/overtochten-passagiers/stedentrip',
      token: '62cd9c52-7517-4059-8aa2-795d588eda17',
      onlineid: '1396990080',
      cbis: widgetSource,
    },
    English: {
      path: '/en-gb/passenger-ferries/city-break',
      token: 'c0c5d4ce-a383-4b9c-a504-c44df787766b',
      onlineid: '1870938646',
      cbis: widgetSource,
    },
    'English Dine': {
      path: '/en-gb/passenger-ferries/city-break-dine',
      token: 'f1b8d8fe-9ab0-422a-9ea3-dd34ac6d860b',
      onlineid: '742696370',
      cbis: widgetSource,
    },
    French: {
      path: '/fr-fr/ferries-passagers/forfaits-de-voyage',
      token: 'e8bc55ef-ff3a-4f00-8a9e-6959e91f6206',
      onlineid: '1145334003',
      cbis: widgetSource,
    },
    'French Dine': {
      path: '/fr-fr/ferries-passagers/forfaits-de-voyage-dine',
      token: '55c89d8c-7df4-45e2-8def-27f413dea3f7',
      onlineid: '432323378',
      cbis: widgetSource,
    },
    German: {
      path: '/de-de/passagierfaehren/paketreisen',
      token: 'cc19c3a4-30ca-4f9a-880b-2330e38e53f7',
      onlineid: '2135187122',
      cbis: widgetSource,
    },
    Lithuania: {
      path: '/lt-lt/keleiviniai-keltai/miesto-atostogos',
      token: '99bca315-0e14-4e87-87bf-b5abe73d93a9',
      onlineid: '254059597',
      cbis: widgetSource,
    },
    Estonia: {
      path: '/et-ee/reisilaevad/linnapuhkus',
      token: 'ba8bb80d-85bb-4554-932e-08abd3ca6edf',
      onlineid: '348431181',
      cbis: widgetSource,
    },
    Norwegian: {
      path: '/nb-no/ferge/storbyferie',
      token: '0b0413d4-4246-4f6c-9519-9f953857b1c6',
      onlineid: '1894031790',
      cbis: widgetSource,
    },
    Swedish: {
      path: '/sv-se/passagerarfartyg/storstadsresor',
      token: '54632571-9ad3-41a4-9438-d0762a44f07a',
      onlineid: '155467449',
      cbis: widgetSource,
    },
  }

  useEffect(() => {
    const widget = document.createElement('script')
    widget.type = 'text/javascript'
    widget.async = true
    widget.fetchpriority = 'high'
    widget.src = `//www.dfds.com${widgetSettings[widgetLocale].path}/widget?token=${widgetSettings[widgetLocale].token}&&cbisProductId=${widgetSettings[widgetLocale].cbis}`
    widget.id = 'TourOperator'
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(widget, s)
  })

  return (
    <FlexCard
      width={gridMap['full-width']}
      mediaWidth={{ md: 8 }}
      media={
        <FlexContainer>
          <FormContainer id={widgetSettings[widgetLocale].token} />
        </FlexContainer>
      }
      reverse
    >
      <Headline as={'h2'}>{title}</Headline>
      <Markdown source={text} />
    </FlexCard>
  )
}

export const TourOperatorWidgetFragment = graphql`
  fragment TourOperatorWidget on contentful_TourOperatorWidget {
    title
    text
    widgetLocale
    widgetSource
  }
`

export default TourOperatorWidget
